import React from 'react'
import { submitLead, toAssignmentPayload } from '../api/leadGeneration'
import { getSessionId } from '../lib/session'
import PublicPage from './PublicPage'

// The assignment template's inputs have ids but no names, so the browser
// would drop them from the submission.
function prepareAssignmentForm(doc) {
  doc.querySelectorAll('input, textarea, select').forEach((field) => {
    if (!field.name && field.id) field.name = field.id
  })

  const form = doc.querySelector('form')
  if (!form) return

  form.querySelectorAll('#d-name, #d-email, #d-phone').forEach((field) => {
    field.required = true
  })
  const name = form.querySelector('#d-name')
  if (name) name.dataset.rsValidate = 'full-name'
}

function submitAssignment(page, form, values) {
  return submitLead(page.publicKey, {
    ...toAssignmentPayload(values),
    sessionId: getSessionId(),
  })
}

function AssignmentPage() {
  return <PublicPage onFormSubmit={submitAssignment} prepareDocument={prepareAssignmentForm} />
}

export default AssignmentPage
